import { D as Direction } from './types-e54f4a51.js';

function getContextDirection(configDirection) {
  if (configDirection !== Direction.rtl && configDirection !== Direction.ltr)
    return null;
  return configDirection;
}

export { getContextDirection as g };
